<!-- 专项行动详情 -->
<template>
  <div class="special-action">
    <div class="header">
      <div class="title">{{ data.describe || '-' }}</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="descriptions-group">
          <div class="descriptions-item">
            <span class="key">问题描述:</span>
            <span class="value">{{ data.describe || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">牵头部门:</span>
            <span class="value">{{ data.leadDepartment || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">所在位置:</span>
            <span class="value">{{ '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">责任单位:</span>
            <span class="value">{{ data.zrxz || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">涉及河流:</span>
            <span class="value">{{ data.hl || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">计划完成时间:</span>
            <span class="value">{{ data.planFinshTimeStr || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">整改措施:</span>
            <span class="value">{{ data.measure || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">完成情况:</span>
            <span class="value">{{ data.state || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'
const props = defineProps({
  // eslint-disable-next-line no-undef
  data: Object,
})
const { data } = toRefs(props)
</script>

<style lang="scss" scoped>
.special-action {
  width: 53.35rem;
  min-width: 53.35rem;
  .header {
    text-align: left;
    margin-bottom: 5px;
    border-bottom: 1px solid #ddd;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 32px;
      font-size: 16px;
    }
  }
  .body {
    .content {
      margin-bottom: 2rem;
      .descriptions-group {
        overflow: hidden;
        h5 {
          font-size: 14px;
          margin: 10px 0;
        }
        .descriptions-item {
          width: 50%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          display: flex;
          &.width100 {
            width: 100%;
          }
          &:last-of-type {
            margin-bottom: 1.4rem;
          }
          .key {
            display: inline-block;
            color: #ffffff;
            flex: 0 0 94px;
            margin-right: 1.9rem;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
